import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProductsSection from '../components/ProductsSection';
import ReviewsSection from '../components/ReviewsSection';
import FoundersSection from '../components/FoundersSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import CartDrawer from '../components/CartDrawer';
import CheckoutModal from '../components/CheckoutModal';
import CombosSection from '../components/CombosSection';
import { Link } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { WhatsAppIcon, WHATSAPP_DISPLAY, waLink, ScrollProgress, AmbientBubbles } from '../components/Effects';

const Home = () => {
  const { isStaff, loadError, reloadStore } = useStore();
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <ScrollProgress />
      <AmbientBubbles />
      <Header onCartClick={() => setCartOpen(true)} />

      <main>
        {loadError && <div role="alert" className="max-w-4xl mx-auto border rounded-xl m-4 p-4 bg-white">We couldn't load the store. Check your connection and <button className="text-primary underline font-semibold" onClick={reloadStore}>try again</button>.</div>}
        <Hero />
        <ProductsSection />
        <CombosSection />
        <ReviewsSection />
        <FoundersSection />
        <ContactSection />
      </main>

      <Footer />

      <a
        data-testid="floating-whatsapp-btn"
        href={waLink('Hi FBD Cleaning, I have a question about your products')}
        target="_blank"
        rel="noreferrer"
        className="wa-float fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1eb355] text-white h-14 w-14 rounded-full flex items-center justify-center transition-transform hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon className="h-8 w-8 relative z-10" />
        <span className="wa-tooltip absolute right-[4.25rem] whitespace-nowrap bg-white text-foreground text-sm font-semibold px-3 py-1.5 rounded-full shadow-lg">
          Chat with us · {WHATSAPP_DISPLAY}
        </span>
      </a>

      {isStaff && (
        <Link
          data-testid="floating-staff-panel-btn"
          to="/staff/b2c"
          className="fixed bottom-6 left-6 z-40 bg-primary hover:bg-primary/90 text-white font-semibold px-5 py-3 rounded-full shadow-lg flex items-center gap-2 transition-transform hover:scale-105"
        >
          Staff Panel
        </Link>
      )}

      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        onCheckout={() => {
          setCartOpen(false);
          setCheckoutOpen(true);
        }}
      />
      <CheckoutModal open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
    </div>
  );
};

export default Home;
